import React from 'react';
import { motion } from 'framer-motion';

function ContactCTA({ socials }) {
  return (
    <section id="contact" className="relative overflow-hidden bg-coal text-white" data-aos="fade-up">
      <div className="pointer-events-none absolute inset-0 flex flex-col justify-center gap-5 overflow-hidden" aria-hidden="true">
        <div className="whitespace-nowrap text-center font-display text-[15vw] font-bold uppercase leading-none tracking-[-0.06em] text-white/[0.06]">
          BUILD TRUST
        </div>
        <div className="whitespace-nowrap text-center font-display text-[15vw] font-bold uppercase leading-none tracking-[-0.06em] text-white/[0.06]">
          BUILD TRUST
        </div>
      </div>

      <div className="section-wrap section-space relative z-10 text-center">
        <p className="mb-6 text-[10px] font-semibold uppercase tracking-[0.35em] text-white/55 md:mb-8">Inquiry</p>
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.45 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="mx-auto max-w-4xl font-display text-[2.4rem] font-bold uppercase leading-[0.9] tracking-[-0.03em] sm:text-5xl md:text-7xl"
        >
          Let&apos;s Build
          <br />
          Something
          <br />
          <span className="italic text-transparent [-webkit-text-stroke:1px_rgba(248,248,247,0.75)]">Exceptional</span>
        </motion.h2>

        <a
          href="mailto:nithinsai2603@gmail.com"
          className="ui-nav-link mt-10 inline-block break-words text-base font-medium tracking-tight underline decoration-white/30 underline-offset-8 hover:opacity-70 sm:text-xl md:mt-12 md:text-4xl"
        >
          nithinsai2603@gmail.com
        </a>

        <div className="mt-10 flex flex-wrap justify-center gap-5 md:mt-14 md:gap-8">
          {socials.map((social) => (
            <a
              key={social.label}
              href={social.href}
              target="_blank"
              rel="noreferrer"
              className="ui-nav-link text-[10px] font-semibold uppercase tracking-[0.2em] text-white/70 hover:text-white"
            >
              {social.label}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ContactCTA;
